import { getCachedMember } from '@tribeplatform/react-sdk/hooks';
import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberKey, getMembersKey, getNetworkKey } from '../../utils/keys';
import { getAuthTokenKey, getAuthMemberKey, } from '../../utils/keys/authToken.keys';
import { useAuthMember } from '../auth/useAuthMember';
export const useUpdateMember = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const { data: authMember } = useAuthMember();
    return useMutation((input) => client.members.update(input, fields), {
        onMutate: async (variables) => {
            const memberInput = variables.input;
            const memberKey = getMemberKey({ variables: { id: variables.id } });
            await queryClient.cancelQueries(memberKey);
            const snapshot = getCachedMember(variables.id, queryClient);
            queryClient.setQueriesData(memberKey, old => ({
                ...old,
                ...memberInput,
                attributes: {
                    ...old === null || old === void 0 ? void 0 : old.attributes,
                    ...memberInput === null || memberInput === void 0 ? void 0 : memberInput.attributes,
                },
            }));
            return { snapshot };
        },
        onSuccess: (updatedMember, vars, context) => {
            var _a;
            const memberKey = getMemberKey({ variables: { id: updatedMember.id } });
            queryClient.setQueriesData(memberKey, oldMember => ({
                ...oldMember,
                ...updatedMember,
            }));
            if (authMember.id === updatedMember.id) {
                queryClient.invalidateQueries(getAuthMemberKey());
            }
            (_a = useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onSuccess) === null || _a === void 0 ? void 0 : _a.call(useMutationOptions, updatedMember, vars, context);
        },
        onError: (err, newMember, context) => {
            var _a;
            const memberKey = getMemberKey({ variables: { id: newMember.id } });
            queryClient.setQueriesData(memberKey, context.snapshot);
            queryClient.invalidateQueries(memberKey);
            (_a = useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError) === null || _a === void 0 ? void 0 : _a.call(useMutationOptions, err, newMember, context);
        },
        onSettled: () => {
            const membersKey = getMembersKey();
            const authTokenKey = getAuthTokenKey();
            const networkKey = getNetworkKey();
            queryClient.invalidateQueries(membersKey);
            queryClient.invalidateQueries(authTokenKey);
            queryClient.invalidateQueries(networkKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateMember.js.map